export const ADD_ALERT = '@alert/ADD_ALERT';
export const ADD_ALERT_SUCCESS = '@alert/ADD_ALERT_SUCCESS';
export const ADD_ALERT_DANGER = '@alert/ADD_ALERT_DANGER';
export const REMOVE_ALERT = '@alert/REMOVE_ALERT';
